<nimbus-filter-summary-button
  cdkOverlayOrigin
  #origin="cdkOverlayOrigin"
  [summary]="summary"
  [filterName]="filter.name"
  [disabled]="disabled"
  [isValueEmpty]="isValueEmpty"
  [hasError]="hasError"
  (summaryClick)="onSummaryClick()"
  (removeFilter)="onRemoveFilter()"
></nimbus-filter-summary-button>

<ng-template
  cdkConnectedOverlay
  cdkConnectedOverlayPanelClass="nimbus-filter-duration-connected-overlay"
  [cdkConnectedOverlayHasBackdrop]="false"
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayPositions]="cdkConnectedPositions"
  [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
  [cdkConnectedOverlayOpen]="isOpen$ | async"
  (attach)="onAttach()"
  (detach)="onDetach()"
  (overlayOutsideClick)="onOutsideClick($event)"
>
  <div class="nimbus-tooltip-complex flex-container tooltip-content">
    <div [formGroup]="form" class="duration-controls">
      <mat-form-field>
        <nimbus-filter-duration-range-input #startControl formControlName="min"></nimbus-filter-duration-range-input>
      </mat-form-field>
      <span class="duration-separator">-</span>
      <mat-form-field>
        <nimbus-filter-duration-range-input #endControl formControlName="max"></nimbus-filter-duration-range-input>
      </mat-form-field>
    </div>
  </div>
</ng-template>
